import React from 'react';

/** Bootstrap Components */
import { Container,Row,Col,Form,Button,Card,Modal } from 'react-bootstrap';  

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';
import SideMenuComponent from './sidemenu';

import { AUTH_URL,CHANGEPWD_URL } from '../utils/constants';

import bcrypt from 'bcryptjs';


class ChangePasswordComponent extends React.Component {  
	constructor(props) {
		super(props);
		this.state = {
			username : '',
			password: '',
			newPassword: '',
			confPassword: '',
			show: false
		}
		this.onChangeCurrentPasswd = this.onChangeCurrentPasswd.bind(this);
		this.onChangeNewPasswd = this.onChangeNewPasswd.bind(this);
		this.onChangeConfirmPasswd = this.onChangeConfirmPasswd.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	componentDidMount() {
		fetch(AUTH_URL,{method:'POST',headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}})
			.then(res => res.json())
			.then(user => {
				this.setState({user: user.username})
			},
			error => {
				alert('Session expired. Redirecting...');
				this.props.history("/login");
				return false;
		}
			)
		.catch(error => {
				alert('Unauthorized Login!!');
				this.props.history("/login");
				return false;
		})

	}

	onChangeCurrentPasswd = (event) =>{
		this.setState({password : event.target.value});
	}
	onChangeNewPasswd = (event) =>{
		this.setState({newPassword : event.target.value});
	}
	onChangeConfirmPasswd = (event) =>{
		this.setState({confPassword : event.target.value});
	}
	submitpassword = (event) =>{
		event.preventDefault();
		var passwd = this.state.password;
		var newpasswd = this.state.newPassword;
		var confPasswd = this.state.confPassword;

		if(passwd === '' || newpasswd === '' || confPasswd === ''){
			alert('Empty values!');
			return false;
		}

		var regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
		if(!regex.test(newpasswd)){
			alert('Invalid Password');
			return false;
		}
		if(newpasswd !== confPasswd){
			alert('Passwords do not match');
			return false;
		}
		passwd = bcrypt.hashSync(passwd,'$2a$10$CwTycUXWue0Thq9StjUM0u');
		newpasswd = bcrypt.hashSync(newpasswd,'$2a$10$CwTycUXWue0Thq9StjUM0u');
		var formData = new FormData();
		const salt = bcrypt.genSaltSync(10);
		formData.append('username',sessionStorage.getItem('user'));
		formData.append('password',salt+passwd);
		formData.append('newpassword',newpasswd);
		
		this.handleOpen();
		fetch(CHANGEPWD_URL,{
				method:'POST',
				body: formData
			})
			.then(res => res.json())
			.then(res => {
				this.handleClose();
				alert('Password Changed successfully!!Please login with new password');
				this.props.history("/login");
				return false;
		})
			.catch(error => {
				this.handleClose();
					alert('Error:: Could not change password!!');
					return false;
				})	
	}
	handleOpen = () =>{
		this.setState({show: true});
	}
	handleClose = () =>{
		this.setState({show: false});
	}

	render() { 
		const { show } = this.state; 
		return (
			<div>
				<NavbarComponent/>
				<nav className="sticky"></nav>
				<header className="App-common main"> 
					<Container className=''>
						<Row className="mt-3">
							<Col sm="4" md="3" lg="3">
								<SideMenuComponent/>
							</Col>
							<Col sm="8" md="9" lg="9">
								<Card className="">
									<Card.Body>
										<Row className='centered-form'>
											<div style={{fontWeight: "bold",fontSize: "large",marginBottom:"10px",borderBottom:"2px solid #3998ac"}}>
												Change Password
											</div>
											<Col className="nomobile"></Col>
											<Col xs="12" sm="12" md="5" lg="5">
											<Form onSubmit={this.submitpassword}>
												<Form.Group className="mb-3" controlId="formOldPassword">
													<Form.Label>Current Password</Form.Label>
													<Form.Control type="password" placeholder="Enter Current Password" onChange={this.onChangeCurrentPasswd} />
												</Form.Group>
												<Form.Group className="mb-3" controlId="formNewPassword">
													<Form.Label>New Password</Form.Label>
													<Form.Control type="password" placeholder="Enter New Password" onChange={this.onChangeNewPasswd} />
												</Form.Group>
												<Form.Group className="mb-3" controlId="formConfPassword">
													<Form.Label>Confirm Password</Form.Label>
													<Form.Control type="password" placeholder="Re-enter New Password" onChange={this.onChangeConfirmPasswd} />
												</Form.Group>
												<Form.Group className="mb-3 text-end" controlId="forBtn">
													<Button variant="primary" type="reset" className='mx-2'>Reset</Button>
													<Button variant="primary" type="submit">Submit</Button>
												</Form.Group>
											</Form>
											<Col>
											<b> Password Criteria: </b>
												<ul>
												<li>At least one capital letter, A-Z</li>
												<li>At least one small letter, a-z</li>
												<li>At least one digit, [0-9]</li>
												<li>At least one special character #?!@$%^&*- </li>
												<li>Minimum eight in length </li>
												</ul>
											</Col>
											</Col>
											<Col className="nomobile col-3"></Col>
										</Row>
									</Card.Body>
								</Card>
							</Col>
						</Row>
					</Container>
				</header>
				<FooterComponent/>
				<Modal size="sm" centered show={show}>
					<Modal.Header>
						<Modal.Title></Modal.Title>
					</Modal.Header>
					<Modal.Body style={{textAlign: 'center'}}>
						<p align='center'>
							Please wait...
							<div className='loader'></div>
						</p>
					</Modal.Body>
				</Modal>
			</div>
		)  
  	}  
}  
export default ChangePasswordComponent